import React, { useCallback, useState } from 'react';
import { Box, Link, Typography } from '@mui/material';
import { IconArrowsSort, IconEdit } from '@tabler/icons-react';
import { useAccounts } from '../../../hooks/Accounts/useAccounts';
import ModalUserDetails from '../modals/modalUserDetails';
import UITable from '../../utilities/Table';
import { SectionHeader, UIPageHeader } from '../../utilities/Headers';
import { UIButton } from '../../utilities/Button';

const UsersOnboardingView = () => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [viewMode, setViewMode] = useState(false);
  const [forceUpdate, setForceUpdate] = useState(false);
  const [filtersData, setFiltersData] = useState({
    order: null,
    treatment_ids: [],
    office_id: null
  });

  const { onListUsersOnboardingAdminPaginated } = useAccounts();

  const handleModalClose = useCallback(() => {
    setViewMode(false);
    setSelectedUser(null);
    setForceUpdate(true);
  }, []);

  const prepareValues = (users) =>
    users?.map((user) => {
      return {
        patient: user,
        patientEl: (
          <Box>
            <Typography fontFamily={'Oxygen'} fontWeight={'700'} fontSize={'14px'}>
              {user?.name} {user?.surname}
            </Typography>
            <Typography fontFamily={'Oxygen'} fontWeight={'700'} fontSize={'13px'} color={'#667085'}>
              <Link
                href={`mailto:${user?.email}`}
                target={'_blank'}
                rel={'noreferrer'}
                component={'a'}
                underline={'always'}
                color={'#667085'}
              >
                {user?.email}
              </Link>
            </Typography>
            <Typography fontFamily={'Oxygen'} fontWeight={'400'} fontSize={'13px'}>
              <Link
                href={`tel:${user?.phone_country?.dial_code}${user?.phone}`}
                target={'_blank'}
                rel={'noreferrer'}
                component={'a'}
                underline={'always'}
                color={'#667085'}
              >
                {user?.phone_country?.dial_code} {user?.phone}
              </Link>
            </Typography>
            {user?.email_otp_code && (
              <Typography fontFamily={'Oxygen'} fontWeight={'700'} fontSize={'14px'}>
                Codice per conferma email: {user?.email_otp_code}
              </Typography>
            )}
          </Box>
        ),
        actionsEl: (
          <Box width={'100%'} display={'flex'} alignItems={'center'} justifyContent={'flex-end'} mr={'15px'}>
            <UIButton
              type={'icon'}
              onClick={() => {
                setSelectedUser(user);
                setViewMode(true);
              }}
              icon={
                <IconEdit
                  stroke={'1.67px'}
                  style={{
                    width: '24px'
                  }}
                />
              }
            />
          </Box>
        )
      };
    });

  const filtersButtons = (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'between',
        alignItems: 'center',
        width: '100%',
        gap: '10px'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          width: '100%',
          gap: '10px'
        }}
      >
        <Box width={'120px'}>
          <UIButton
            icon={
              <IconArrowsSort
                stroke={'1.64'}
                size={'20px'}
                style={{
                  marginRight: 5,
                  width: '20px'
                }}
              />
            }
            checked={filtersData?.order !== null}
            label={'ABC'}
            type={'filter'}
            onClick={() => {
              setFiltersData({
                ...filtersData,
                order: filtersData?.order === 'ASC' ? null : 'ASC'
              });
            }}
          />
        </Box>
      </Box>
    </Box>
  );

  return (
    <Box className="products-view" w={'100%'} h={'100%'} overflow={'auto'}>
      <ModalUserDetails modalOpen={viewMode} handleModalClose={handleModalClose} userRow={selectedUser} />

      <UIPageHeader
        title={'Pazienti incompleti'}
        subtitle={"Gestisci qui i pazienti incompleti. In questa lista appariranno solo  i pazienti che non hanno completato l'onboarding."}
      />

      <SectionHeader title={'Paziente'} />
      <UITable
        columns={[
          {
            name: 'Paziente',
            value: 'patientEl',
            size: 120
          },
          {
            name: 'OnBoarding Completato',
            value: 'onBoardingEl',
            size: 100
          },
          {
            name: '',
            value: 'actionsEl',
            size: 80
          }
        ]}
        prepareValues={prepareValues}
        enableSearch={true}
        searchSubtitle={`E' possibile cercare per email, unico dato univoco fornito dal paziente in fase di iscrizione.`}
        enableCustomFilters={true}
        filtersData={filtersData}
        filtersButtons={filtersButtons}
        tableHeight={'calc(100vh - 400px)'}
        forceUpdate={forceUpdate}
        setForceUpdate={setForceUpdate}
        infiniteScrollEndMessage={'Non ci sono altri utenti da mostrare'}
        infiniteScrollFunction={onListUsersOnboardingAdminPaginated}
      />
    </Box>
  );
};
export default UsersOnboardingView;
